<div style="padding-top: 24px; padding-bottom: 24px" xmlns="http://www.w3.org/1999/html" [attr.data-cy]="'cktkt_div_1'">
    <mat-card [attr.data-cy]="'cktkt_mat-card_1'">
        <div class="kiene-table-header" [attr.data-cy]="'cktkt_div_2'">
            <h1 *ngIf="tableDescriptor.headline?.length > 0">
                <span [attr.data-cy]="'cktkt_h1'">{{ tableDescriptor.headline }}</span>
                <small [attr.data-cy]="'cktkt_h1_1'" style="padding-left: 5px">({{ this.totalCount }})</small>
            </h1>
            <mat-chip-list *ngIf="selection?.selected?.length > 0" style="margin-left: 24px">
                <mat-chip (removed)="clearSelection()">
                    <span>{{ selection?.selected?.length }} Elemente selektiert</span>
                    <button matChipRemove matTooltip="Selektion löschen">
                        <mat-icon [attr.data-cy]="'cktkt_mat-icon_1'">cancel</mat-icon>
                    </button>
                </mat-chip>
            </mat-chip-list>
            <span class="spacer"></span>

            <ng-content select="[toolbarElementCenter]"></ng-content>
            <span class="spacer"></span>

            <div class="one-row" style="width: fit-content" [attr.data-cy]="'cktkt_div_3'">
                <!-- Custom elements -->
                <ng-content select="[toolbarElementTop]"></ng-content>

                <ng-container *ngIf="tableDescriptor.filterItems?.length > 0">
                    <button
                        [matMenuTriggerFor]="filterMenu"
                        color="accent"
                        mat-icon-button
                        matTooltip="Filtern"
                        style="display: inline-block"
                    >
                        <mat-icon [matBadge]="checkedFilterCount" [attr.data-cy]="'cktkt_mat-icon_2'"
                            >filter_list</mat-icon
                        >
                    </button>
                    <mat-menu #filterMenu="matMenu" [class]="'filter_menu'">
                        <kiene-filter
                            (checkedFilterCount)="setCheckedFilterCount($event)"
                            (updatedFilterItems)="updatedFilterItems($event)"
                            [filterItems]="tableDescriptor.filterItems"
                            [tablename]="tableDescriptor.headline"
                            clickStopPropagation
                        >
                        </kiene-filter>
                    </mat-menu>
                </ng-container>
                <ng-container *kienePermission="tableDescriptor.permissionsCreate?.length ? tableDescriptor.permissionsCreate : [tableDescriptor.permissionCreate]">
                    <div *ngIf="tableDescriptor.standardCreate && tableDescriptor.createAllowed">
                        <button
                            (click)="createNew()"
                            [matTooltip]="
                                tableDescriptor?.tooltips['add_button']
                                    ? tableDescriptor?.tooltips['add_button']
                                    : 'Neuen Datensatz erstellen'
                            "
                            color="accent"
                            mat-icon-button
                            [attr.data-cy]="'cktkt_button_3'"
                        >
                            <mat-icon [attr.data-cy]="'cktkt_mat-icon_3'">add</mat-icon>
                        </button>
                    </div>
                </ng-container>
                <ng-container *kienePermission="tableDescriptor.permissionsCreate?.length ? tableDescriptor.permissionsCreate : [tableDescriptor.permissionCreate]">
                    <div
                        *ngIf="!tableDescriptor.standardCreate && tableDescriptor.createAllowed"
                        [attr.data-cy]="'cktkt_div_4'"
                    >
                        <button
                            (click)="clickedAdd()"
                            [matTooltip]="
                                tableDescriptor?.tooltips['add_button']
                                    ? tableDescriptor?.tooltips['add_button']
                                    : 'Neuen Datensatz erstellen'
                            "
                            color="accent"
                            mat-icon-button
                            [attr.data-cy]="'cktkt_button_4'"
                        >
                            <mat-icon [attr.data-cy]="'cktkt_mat-icon_4'">add</mat-icon>
                        </button>
                    </div>
                </ng-container>
                <div *ngFor="let tb of tableDescriptor.selectionToolbarButtons; let i = index">
                    <button
                        (click)="clickedSelectionToolbarButton(tb)"
                        *kienePermission="[tb.permission]"
                        [disabled]="
                            tb.disableOnEmptySelection &&
                            (selection?.selected?.length < 1 || !tb.checkConditions(selection?.selected))
                        "
                        [matTooltip]="tb.tooltip + ' Selektiert: (' + selection?.selected?.length + ')'"
                        color="accent"
                        mat-icon-button
                        style="display: inline-block"
                        [attr.data-cy]="'cktkt_button_5' + i"
                    >
                        <mat-icon [attr.data-cy]="'cktkt_mat-icon_5' + i">{{ tb.icon }}</mat-icon>
                    </button>
                </div>
                <div *ngFor="let tb of tableDescriptor.toolbarButtons; let i = index">
                    <button
                        (click)="clickedToolbar(tb)"
                        *kienePermission="[tb.permission]"
                        [matTooltip]="tb.tooltip"
                        color="accent"
                        mat-icon-button
                        style="display: inline-block"
                        [attr.data-cy]="'cktkt_button_6' + i"
                    >
                        <mat-icon [attr.data-cy]="'cktkt_mat-icon_6' + i">{{ tb.icon }}</mat-icon>
                    </button>
                </div>
                <div *ngIf="showColumnFilter && tableDescriptor.uniqueIdentifier">
                    <button
                        (click)="openFilterDialog()"
                        color="accent"
                        mat-icon-button
                        matTooltip="Spalten auswählen"
                        [disabled]="isLoading"
                        style="display: inline-block"
                    >
                        <mat-icon [attr.data-cy]="'cktkt_mat-icon_7'">view_week</mat-icon>
                    </button>
                </div>
                <div *ngIf="tableDescriptor.showRefresh">
                    <button
                        (click)="reload('button')"
                        color="accent"
                        mat-icon-button
                        matTooltip="Daten aktualisieren"
                        style="display: inline-block"
                    >
                        <mat-icon *ngIf="!isLoading" [attr.data-cy]="'cktkt_mat-icon_8'">refresh</mat-icon>
                        <mat-spinner *ngIf="isLoading" [diameter]="20" style="margin-left: 9px"></mat-spinner>
                    </button>
                </div>
                <div *ngIf="showDownloads()">
                    <button
                        [matMenuTriggerFor]="downloadMenu"
                        color="accent"
                        mat-icon-button
                        style="display: inline-block"
                        [attr.data-cy]="'cktkt_button_9'"
                    >
                        <mat-icon [attr.data-cy]="'cktkt_mat-icon_9'">download</mat-icon>
                    </button>
                    <mat-menu #downloadMenu="matMenu">
                        <button (click)="download_csv()" mat-menu-item [attr.data-cy]="'cktkt_button_10'">
                            <mat-icon color="accent" [attr.data-cy]="'cktkt_mat-icon_10'">download</mat-icon>
                            <span>Ansicht als CSV herunterladen</span>
                        </button>
                        <button (click)="download_excel()" mat-menu-item [attr.data-cy]="'cktkt_button_11'">
                            <mat-icon color="accent" [attr.data-cy]="'cktkt_mat-icon_11'">download</mat-icon>
                            <span>Ansicht als Excel herunterladen</span>
                        </button>
                    </mat-menu>
                </div>

                <!-- <div *ngIf="tableDescriptor.params" style="width: 50px;">
            <button style="display: inline-block;" mat-icon-button color="accent" (click)="clearExternalParams()"  [attr.data-cy]="cktkt_button_12">
              <mat-icon   [attr.data-cy]="cktkt_mat-icon_12">clear</mat-icon>
            </button>
        </div> -->
            </div>
        </div>

        <div *ngIf="tableDescriptor.showSearchBar">
            <mat-form-field style="width: 100%">
                <mat-label>{{ tableDescriptor.searchPlaceholder }}</mat-label>
                <input
                    #searchInput="matInput"
                    [formControl]="searchCtrl"
                    matInput
                    maxlength="200"
                    [attr.data-cy]="'cktkt_input_1'"
                />
            </mat-form-field>
        </div>

        <!-- Custom elements -->
        <ng-content select="[toolbarElementMiddle]"></ng-content>

        <div #tableScrollContainer class="kiene-table-container" (scroll)="onTableHorizontalScroll()">
            <table
                #table
                [dataSource]="tableDataSource"
                [matSortActive]="tableDescriptor.initialSortColumn"
                [matSortDirection]="initialSortDirection"
                class="kiene-table"
                [class.kiene-table--with-options]="
                    tableDescriptor?.options?.length > 0 && !tableDescriptor?.skipOptionsTablePadding
                "
                mat-table
                matSort
                matSortDisableClear
                multiTemplateDataRows
            >
            <ng-container matColumnDef="select">
                <th *matHeaderCellDef mat-header-cell style="min-width: 50px">
                    <mat-checkbox
                        (change)="masterSelectionToggle($event)"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                        [attr.data-cy]="'cktkt_mat-checkbox_1'"
                    >
                    </mat-checkbox>
                </th>
                <td *matCellDef="let row; let i = index" mat-cell>
                    <mat-checkbox
                        (change)="changeSelection($event, row)"
                        [checked]="isRowSelected(row)"
                        [attr.data-cy]="'cktkt_mat-checkbox_2' + i"
                    >
                    </mat-checkbox>
                </td>
            </ng-container>
            <ng-container *ngFor="let c of getColumns(); let i = index" [matColumnDef]="c.name">
                <ng-container *ngIf="!c.isSortable">
                    <th
                        *matHeaderCellDef
                        mat-header-cell
                        [style.max-width]="c.maxWidth"
                        [attr.data-cy]="'cktkt_th_1_' + i"
                    >
                        {{ c.title }}
                        <ng-container *ngIf="tableDescriptor?.totalRow && tableDataSource?.data?.length > 1">
                            <br />{{ getSumValue(c.name) }}
                        </ng-container>
                    </th>
                </ng-container>
                <ng-container *ngIf="c.isSortable">
                    <th
                        *matHeaderCellDef
                        mat-header-cell
                        mat-sort-header
                        [style.max-width]="c.maxWidth"
                        [attr.data-cy]="'cktkt_span_2_' + i"
                        >{{ c.title }}
                        <ng-container *ngIf="tableDescriptor?.totalRow && tableDataSource?.data?.length > 1">
                            <br /><span [attr.data-cy]="'cktkt_span_3_' + i">{{ getSumValue(c.name) }}</span>
                        </ng-container>
                    </th>
                </ng-container>
                <td
                    *matCellDef="let row"
                    [ngStyle]="{ cursor: tableDescriptor.showDetails ? 'pointer' : '', color: getColor(row) }"
                    [style.max-width]="c.maxWidth"
                    mat-cell
                    style="white-space: pre-wrap"
                >
                    <div
                        (click)="showDetails(row)"
                        *ngIf="c.type === 'date'"
                        [attr.data-cy]="'cktkt_span_4_' + row.recposition + '_' + i"
                    >
                        <span *ngIf="getValue(row, c.name)">{{ getValue(row, c.name) | date: c.format }}</span>
                        <span *ngIf="!getValue(row, c.name) && getValue(row, c.alternativeField)">
                            {{ getValue(row, c.alternativeField) }}
                        </span>
                    </div>
                    <div
                        (click)="showDetails(row)"
                        *ngIf="c.type === 'datetime'"
                        [attr.data-cy]="'cktkt_span_6_' + row.recposition + '_' + i"
                        >{{ getValue(row, c.name) | date: "dd.MM.yy HH:mm:ss" }}
                    </div>
                    <div
                        (click)="showDetails(row)"
                        *ngIf="c.type === 'rawLocalDateTime'"
                        [attr.data-cy]="'cktkt_span_7_' + row.recposition + '_' + i"
                        >{{ getDateFromRawLocalDateTime(row, c.name) | date: "dd.MM.yy" }}
                    </div>
                    <div *ngIf="c.type === 'boolean'">
                        <ng-container *ngIf="!(c.clickable === true)">
                            <mat-icon
                                (click)="showDetails(row)"
                                *ngIf="getValue(row, c.name) > 0"
                                [matTooltip]="getValue(row, c.tooltipFieldname)"
                                color="primary"
                                [attr.data-cy]="'cktkt_mat-icon_13_' + row.recposition + '_' + i"
                                >check_circle
                            </mat-icon>
                            <mat-icon
                                (click)="showDetails(row)"
                                *ngIf="!(getValue(row, c.name) > 0)"
                                color="primary"
                                [attr.data-cy]="'cktkt_mat-icon_14_' + row.recposition + '_' + i"
                                >radio_button_unchecked
                            </mat-icon>
                        </ng-container>
                        <ng-container *ngIf="c.clickable === true">
                            <mat-checkbox
                                (change)="checkboxChanged($event, c, row)"
                                [checked]="getValue(row, c.name) > 0"
                                [attr.data-cy]="'cktkt_mat-checkbox_3_' + row.recposition + '_' + i"
                                [disabled]="!c.checkConditions(row) || !hasPermission(c.permissionId)"
                            ></mat-checkbox>
                        </ng-container>
                    </div>
                    <div *ngIf="c.type === 'slideToggle'">
                        <mat-slide-toggle
                            (change)="slideToggled(c, row, $event)"
                            [checked]="!!getValue(row, c.name)"
                            [attr.data-cy]="'cktkt_mat-slide-toggle_1_' + row.recposition + '_' + i"
                        >
                        </mat-slide-toggle>
                    </div>
                    <div
                        (click)="showDetails(row)"
                        *ngIf="c.type === 'string'"
                        [matTooltip]="getHintTooltip(c, row)"
                        [matTooltipDisabled]="!shouldShowHintTooltip(c, row)"
                        matTooltipClass="kiene-table-copyable-tooltip"
                        [style.max-width]="c.maxWidth"
                        class="text-column"
                        style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap"
                        [attr.data-cy]="'cktkt_th_8_' + row.recposition + '_' + i"
                    >
                        {{
                            c.maxLength ? getTruncatedDisplayText(c, row) : getValue(row, c.name)
                        }}
                    </div>
                    <div
                        (click)="showDetails(row)"
                        *ngIf="c.type === 'number'"
                        [attr.data-cy]="'cktkt_span_9_' + row.recposition + '_' + i"
                        >{{
                            (getValue(row, c.name) !== undefined && getValue(row, c.name) !== null
                                ? getValue(row, c.name)
                                : ""
                            ) | number: c.format
                        }}{{ c.unit && getValue(row, c.name) !== null ? " " + c.unit : "" }}
                    </div>
                    <div (click)="showDetails(row)" *ngIf="c.type === 'text'">
                        <span
                            [ngStyle]="{
                                'font-family': c.fontFamily,
                                'font-size': c.fontSize,
                                'letter-spacing': c.letterSpacing,
                                'max-width': c.maxWidth
                            }"
                            [matTooltip]="getHintTooltip(c, row)"
                            [matTooltipDisabled]="!shouldShowHintTooltip(c, row)"
                            matTooltipClass="kiene-table-copyable-tooltip"
                            class="text-column text-column--inline"
                            [attr.data-cy]="'cktkt_span_11_' + row.recposition + '_' + i"
                            ><span *ngIf="c.prefix">{{ c.prefix }}</span>
                            {{
                                c.maxLength
                                    ? getTruncatedDisplayText(c, row)
                                    : getValue(row, c.name)
                            }}
                            <span *ngIf="c.suffix">{{ c.suffix }}</span>
                        </span>
                        <mat-icon
                            *ngIf="c.copyToClipboard"
                            style="color: #bbbbbb; margin-left: 6px"
                            (click)="$event.stopPropagation(); copyToClipboard(row, c.name)"
                            matTooltip="kopieren"
                            [attr.data-cy]="'cktkt_mat-icon_15_' + row.recposition + '_' + i"
                            >content_copy
                        </mat-icon>
                    </div>
                    <div
                        (click)="showDetails(row)"
                        *ngIf="c.type === 'ohrmarke'"
                        style="font-size: 0.8em"
                        [attr.data-cy]="'cktkt_div_6_' + row.recposition + i"
                    >
                        <kiene-ohrmarke [ohrmarke]="getValue(row, c.name)"></kiene-ohrmarke>
                    </div>
                    <div *ngIf="c.type === 'pdf'">
                        <button
                            (click)="clickedPdf(c, row)"
                            *ngIf="getValue(row, c.name)"
                            color="accent"
                            mat-icon-button
                            matTooltip="PDF anzeigen"
                            [attr.data-cy]="'cktkt_button_13_' + row.recposition + '_' + i"
                        >
                            <mat-icon [attr.data-cy]="'cktkt_mat-icon_16_' + row.recposition + '_' + i"
                                >cloud_download</mat-icon
                            >
                        </button>
                    </div>
                    <div (click)="showDetails(row)" *ngIf="c.type === 'status'">
                        <div
                            [style.background-color]="getStatusBackgroundColor(c, row)"
                            class="status-field"
                            [attr.data-cy]="'cktkt_span_14_' + row.recposition + '_' + i"
                            >{{ getValue(row, c.name) }}
                        </div>
                    </div>
                    <div (click)="showDetails(row)" *ngIf="c.type === 'color'">
                        <div
                            [ngStyle]="{ 'background-color': getValue(row, c.name) }"
                            style="width: 50px; min-height: 12px"
                            [attr.data-cy]="'cktkt_div_7_' + row.recposition + '_' + i"
                        ></div>
                    </div>
                    <div
                        (click)="showDetails(row)"
                        *ngIf="c.type === 'ConditionTableColumn'"
                        [attr.data-cy]="'cktkt_span_15_' + row.recposition + '_' + i"
                    >
                        <mat-icon
                            [matTooltip]="getTooltip(c, row)"
                            [ngStyle]="{ color: getIconColor(c, row) }"
                            [attr.data-cy]="'cktkt_mat-icon_17_' + i"
                        >
                            {{ getIconName(c, row) }}
                        </mat-icon>
                    </div>
                    <div
                        (click)="showDetails(row)"
                        *ngIf="c.type === 'function'"
                        [matTooltip]="getFunctionFullText(c, row)"
                        [matTooltipDisabled]="!shouldShowFunctionTooltip(c, row)"
                        matTooltipClass="kiene-table-copyable-tooltip"
                        [style.max-width]="c.maxWidth"
                        class="text-column text-column--inline"
                        [attr.data-cy]="'cktkt_span_16_' + row.recposition + '_' + i"
                        >{{
                            c.maxLength ? getFunctionDisplayText(c, row) : executeCallback(row, c)
                        }}
                    </div>
                    <div
                        (click)="showDetails(row)"
                        *ngIf="c.type === 'ifelse'"
                        [attr.data-cy]="'cktkt_span_17_' + row.recposition + '_' + i"
                        >{{ ifElseValue(row, c) }}
                    </div>
                    <div
                        (click)="showDetails(row)"
                        *ngIf="c.type === 'arrayLength'"
                        [attr.data-cy]="'cktkt_span_18_' + row.recposition + '_' + i"
                        >{{ getValue(row, c.name)?.length }}
                    </div>
                    <div *ngIf="c.type === 'json'" style="max-width: 400px">
                        <button
                            (click)="openJsonDialog(getValue(row, c.name))"
                            color="accent"
                            mat-icon-button
                            [attr.data-cy]="'cktkt_button_14_' + row.recposition + '_' + i"
                        >
                            <mat-icon [attr.data-cy]="'cktkt_mat-icon_18_' + row.recposition + '_' + i">star</mat-icon>
                        </button>
                    </div>
                    <div *ngIf="c.type === 'array'">
                        <div *ngFor="let elem of getValue(row, c.name); let ie = index" style="padding: 6px">
                            <div *ngIf="c?.displayFields?.length > 0">
                                <span
                                    *ngFor="let displayField of c.displayFields; let id = index"
                                    [attr.data-cy]="'cktkt_span_19_' + row.recposition + '_' + i + '_' + ie + '_' + id"
                                    >{{ elem[displayField] }}&nbsp;
                                </span>
                            </div>
                            <div *ngIf="c?.displayFields?.length < 1">
                                <span [attr.data-cy]="'cktkt_span_19_' + row.recposition + '_' + i + '_' + ie"
                                    >{{ elem }}&nbsp;</span
                                >
                            </div>
                        </div>
                        <br />
                    </div>
                    <div
                        (click)="showDetails(row)"
                        *ngIf="c.type === 'url'"
                        [matTooltip]="getValue(row, c.hint)"
                        [style.max-width]="c.maxWidth"
                        class="text-column"
                    >
                        <div [innerHTML]="parseStringForUrl(getValue(row, c.name))" [attr.data-cy]="'cktkt_div_1' + i">
                        </div>
                    </div>
                    <div *ngIf="c.type === 'link'" class="text-column">
                        <a
                            *ngIf="getValue(row, c.nameOfIdField)"
                            [queryParams]="createQueryParams(c, row)"
                            [routerLink]="[c.path, getValue(row, c.nameOfIdField)]"
                            class="kiene-link"
                            [attr.data-cy]="'cktkt_a_1' + i"
                            >{{ getValue(row, c.name) }}</a
                        >
                    </div>
                    <div *ngIf="c.type === 'ActionTableColumn'">
                        <ng-container *ngIf="hasViewPermission(c)">
                            <button
                                *ngIf="c.checkConditions(row)"
                                (click)="emitActionEvent(row, c)"
                                [matTooltip]="c.tooltip"
                                color="accent"
                                mat-icon-button
                                [attr.data-cy]="'cktkt_button_15' + i"
                            >
                                <mat-icon [attr.data-cy]="'cktkt_mat-icon_19' + i">{{ c.iconName }}</mat-icon>
                            </button>
                        </ng-container>
                    </div>

                    <div *ngIf="c.type === 'input'" class="text-column">
                        <div class="one-row">
                            <mat-form-field appearance="standard">
                                <input [(ngModel)]="row[c.name]" matInput [attr.data-cy]="'cktkt_input_2' + i" />
                            </mat-form-field>
                            <button (click)="saveInput(row, c)" mat-icon-button [attr.data-cy]="'cktkt_button_16' + i">
                                <mat-icon color="accent" [attr.data-cy]="'cktkt_mat-icon_20' + i">save</mat-icon>
                            </button>
                        </div>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="dragHandle">
                <th *matHeaderCellDef mat-header-cell></th>
                <td *matCellDef="let row; let i = index" cdkDragHandle mat-cell style="cursor: move">
                    <mat-icon [attr.data-cy]="'cktkt_amt-icon_21_' + i">menu</mat-icon>
                </td>
            </ng-container>

            <ng-container matColumnDef="options" stickyEnd>
                <th *matHeaderCellDef mat-header-cell></th>
                <td *matCellDef="let row; let i = dataIndex" mat-cell>
                    <mat-menu #optionsMenu>
                        <ng-template matMenuContent>
                            <div *ngFor="let o of tableDescriptor.options; let ib = index">
                                <button
                                    (click)="clickedTableOption(o, row)"
                                    *kienePermission="[o.permissionId]"
                                    [disabled]="!o.checkConditions(row) || !!o.isDisabled?.(row)"
                                    mat-menu-item
                                    [attr.data-cy]="'cktkt_button_17_' + i + '_' + ib"
                                >
                                    <mat-icon [attr.data-cy]="'cktkt_mat-icon_22_' + i + '_' + ib">{{
                                        o.icon
                                    }}</mat-icon>
                                    <span [attr.data-cy]="'cktkt_button_17_text_' + i + '_' + ib"> {{ o.title }} </span>
                                </button>
                            </div>
                        </ng-template>
                    </mat-menu>
                    <button
                        *ngIf="hasAtLeastOneOptionPermission()"
                        [matMenuTriggerFor]="optionsMenu"
                        mat-icon-button
                        matTooltip="Menü öffnen"
                        [attr.data-cy]="'cktkt_button_18_'"
                    >
                        <mat-icon [attr.data-cy]="'cktkt_mat-icon_23_' + i">more_vert</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="entityViewerButton">
                <th *matHeaderCellDef mat-header-cell></th>
                <td *matCellDef="let row; let i = index" mat-cell>
                    <button
                        (click)="ladeEntityInEntityViewer(row)"
                        mat-icon-button
                        matTooltip="Lade Entity in EntityViewer"
                        [attr.data-cy]="'cktkt_button_19' + i"
                    >
                        <mat-icon [attr.data-cy]="'cktkt_mat-icon_24' + i">developer_mode</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="detailsButton">
                <th *matHeaderCellDef mat-header-cell></th>
                <td *matCellDef="let row" mat-cell>
                    <button
                        (click)="expand(row)"
                        mat-icon-button
                        matTooltip="Details öffnen"
                        [attr.data-cy]="'cktkt_button_20'"
                    >
                        <mat-icon [attr.data-cy]="'cktkt_mat-icon_25'"
                            >{{ isExpanded(row) ? "expand_less" : "expand_more" }}
                        </mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
                <td *matCellDef="let row; let it = index" [attr.colspan]="getAllColumnsLength()" mat-cell>
                    <div
                        *ngIf="tableDescriptor?.expandable"
                        [@detailExpand]="isExpanded(row) === true ? 'expanded' : 'collapsed'"
                        class="example-element-detail"
                    >
                        <div [ngStyle]="{ color: getColor(row) }" style="width: 100%" class="example-element-detail-inner">
                            <table class="details-table">
                                <thead>
                                    <tr [attr.data-cy]="'cktkt_tr_1' + it">
                                        <th
                                            *ngFor="let tc of getExpandableColumns(); let itc = index"
                                            style="text-align: left; font-size: 0.9em; color: gray; font-weight: 400"
                                            [attr.data-cy]="'cktkt_span_22_' + it + '_' + itc"
                                            >{{ tc.title }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        (click)="clickedOnExpandedTable(row)"
                                        *ngFor="
                                            let r of getExpandableRows(row);
                                            let ir = index
                                        "
                                        [style.cursor]="'auto'"
                                        [attr.data-cy]="'cktkt_tr_2' + ir"
                                    >
                                        <td
                                            *ngFor="let tc of getExpandableColumns(); let itc = index"
                                            style="
                                                padding-top: 12px;
                                                padding-bottom: 12px;
                                                border-bottom: 1px solid #ddd;
                                                white-space: pre-wrap;
                                            "
                                        >
                                            <div
                                                *ngIf="tc.type === 'function'"
                                                [attr.data-cy]="'cktkt_div_2_' + ir + '_' + itc"
                                            >
                                                {{ executeCallback(r, tc) }}
                                            </div>
                                            <div
                                                *ngIf="tc.type === 'number'"
                                                [attr.data-cy]="'cktkt_div_3_' + ir + '_' + itc"
                                            >
                                                {{ r[tc.name] | number: tc.format }}
                                            </div>
                                            <div
                                                *ngIf="tc.type === 'date'"
                                                [attr.data-cy]="'cktkt_div_4_' + ir + '_' + itc"
                                            >
                                                {{ r[tc.name] | date: tc.format }}
                                            </div>
                                            <div
                                                *ngIf="tc.type === 'string'"
                                                [attr.data-cy]="'cktkt_div_5_' + ir + '_' + itc"
                                            >
                                                {{ r[tc.name] }}
                                            </div>
                                            <div *ngIf="tc.type === 'boolean'">
                                                <ng-container *ngIf="!(tc.clickable === true)">
                                                    <mat-icon
                                                        (click)="showDetails(r)"
                                                        *ngIf="getValue(r, tc.name) > 0"
                                                        [attr.data-cy]="'cktkt_mat-icon_26_' + ir + '_' + itc"
                                                        [matTooltip]="getValue(r, tc.tooltipFieldname)"
                                                        color="primary"
                                                        >check_circle
                                                    </mat-icon>
                                                    <mat-icon
                                                        (click)="showDetails(r)"
                                                        *ngIf="!(getValue(r, tc.name) > 0)"
                                                        color="primary"
                                                        [attr.data-cy]="'cktkt_mat-icon_27_' + ir + '_' + itc"
                                                    >
                                                        radio_button_unchecked
                                                    </mat-icon>
                                                </ng-container>
                                                <ng-container *ngIf="tc.clickable === true">
                                                    <mat-checkbox
                                                        (change)="checkboxChanged($event, tc, r)"
                                                        [checked]="getValue(r, tc.name) > 0"
                                                        [attr.data-cy]="'cktkt_mat-checkbox_4' + ir + '_' + itc"
                                                        [disabled]="
                                                            !tc.checkConditions(r) || !hasPermission(tc.permissionId)
                                                        "
                                                    ></mat-checkbox>
                                                </ng-container>
                                            </div>
                                            <div
                                                (click)="showDetails(r)"
                                                *ngIf="tc.type === 'ifelse'"
                                                [attr.data-cy]="'cktkt_div_5_' + ir + '_' + itc"
                                            >
                                                {{ ifElseValue(r, tc) }}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr
                                        *ngIf="showExpandableTotal(row)"
                                        class="expandable-total-row"
                                        [attr.data-cy]="'cktkt_tr_total_' + it"
                                    >
                                        <td
                                            *ngFor="let tc of getExpandableColumns(); let itc = index"
                                            class="expandable-total-cell"
                                        >
                                            <ng-container *ngIf="itc === 0">Insgesamt</ng-container>
                                            <ng-container *ngIf="itc > 0 && isExpandableSumColumn(tc)">
                                                {{ getExpandableColumnSum(row, tc.name) | number: (tc.format || '1.2-2') }}
                                            </ng-container>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </td>
            </ng-container>

                <tr *matHeaderRowDef="displayedColumns" mat-header-row [attr.data-cy]="'cktkt_tr_3'"></tr>
                <tr
                    (onFileDropped)="uploadFiles($event, row)"
                    *matRowDef="let row; let i = dataIndex; columns: displayedColumns"
                    [class.example-expanded-row]="isExpanded(row)"
                    class="example-element-row"
                    kieneDropFile
                    mat-row
                    [attr.data-cy]="'cktkt_tr_4_' + i"
                ></tr>
                <tr
                    *matRowDef="
                        let row;
                        columns: ['expandedDetail']
                    "
                    class="example-detail-row"
                    mat-row
                    [attr.data-cy]="'cktkt_tr_5'"
                ></tr>
            </table>
        </div>
        <div
            #bottomScrollbar
            class="kiene-horizontal-scrollbar"
            [class.hidden]="!showHorizontalScrollbar"
            (scroll)="onBottomScrollbarScroll()"
        >
            <div class="kiene-horizontal-scrollbar-content" [style.width.px]="horizontalScrollWidth"></div>
        </div>
        <div
            #floatingStickyHeader
            *ngIf="tableDescriptor.stickyHeader"
            class="kiene-floating-header"
            [class.kiene-floating-header--visible]="stickyHeaderVisible"
        >
            <div #floatingStickyHeaderInner class="kiene-floating-header-inner">
                <div
                    *ngFor="let cell of stickyHeaderCells"
                    class="kiene-floating-header-cell"
                    [class.kiene-floating-header-cell--options]="cell.isOptions"
                    [style.width.px]="cell.width"
                    [style.minWidth.px]="cell.width"
                    [style.maxWidth.px]="cell.width"
                    [style.height.px]="stickyHeaderHeight"
                >
                    {{ cell.label }}
                </div>
            </div>
        </div>
        <mat-paginator
            [length]="totalCount"
            [pageSizeOptions]="tableDescriptor.pageSizeOptions"
            [pageSize]="tableDescriptor.defaultPageSize"
            showFirstLastButtons
        ></mat-paginator>
    </mat-card>
</div>
